import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  public transform(value: string, limit = 25, completeWords = false, ellipsis = '...'): string {
    if (typeof value !== 'string') {
      return '';
    }

    if (completeWords) {
      const truncated = value.substring(0, limit);
      const lastSpace = truncated.lastIndexOf(' ');
      if (lastSpace !== -1 && truncated.length === limit) {
        limit = lastSpace;
      }
    }

    return value.length > limit ? value.substring(0, limit) + ellipsis : value;
  }
}
